import Joi from "joi";

const OrderCreamGetStartedSchema = Joi.object({
  firstName: Joi.string().required().messages({
    "string.base": "First name must be a string.",
    "string.empty": "First name is required.",
  }),
  lastName: Joi.string().required().messages({
    "string.base": "Last name must be a string.",
    "string.empty": "Last name is required.",
  }),
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .required()
    .messages({
      "string.base": "Email must be a string.",
      "string.email": "Email must be a valid email address.",
      "string.empty": "Email is required.",
    }),
});
const OrderCreamPainProfileSchema = Joi.object({
  painLocations: Joi.array().items(Joi.string()).min(1).required().messages({
    "array.min":
      "You Should At least mark one location of the pain at your body",
    "any.required":
      "You Should At least mark one location of the pain at your body",
  }),
  painRating: Joi.number().required().min(0).max(10).messages({
    "number.base": "Pain rating must be a number.",
    "number.empty": "Pain rating is required.",
    "number.min": "Pain rating must be at least 0.",
    "number.max": "Pain rating must be at most 10.",
  }),
  painDuration: Joi.string()
    .valid("acute", "chronic")
    .required()
    .messages({
      "string.base": "Please choose a duration.",
      "string.empty": "Please choose a duration.",
      "any.required": "Please choose a duration.",
      "any.only": "Please choose a duration.",
      "any.invalid": "Please choose a duration.",
    })
    .invalid("", null, "pending"),
  painDescriptions: Joi.array().items(Joi.string()).min(1).required().messages({
    "array.min": "Please choose a pain description.",
    "array.required": "Pain description is required.",
  }),
});

const OrderCreamPainFactorsSchema = Joi.object({
  physicalActivity: Joi.string()
    .valid("sedentary", "light", "moderate", "high")
    .required()
    .messages({
      "string.base": "Please choose a physical activity.",
      "string.empty": "Please choose a physical activity.",
      "any.required": "Please choose a physical activity.",
      "any.only": "Please choose a physical activity.",
      "any.invalid": "Please choose a physical activity.",
    })
    .invalid("", null, "pending"),
  painWorseDescriptions: Joi.array()
    .items(Joi.string())
    .min(1)
    .required()
    .messages({
      "array.min": "Please choose at least one that makes your pain worse.",
      "array.required":
        "Please choose at least one that makes your pain worse.",
    }),
});

const OrderCreamPainSymptomsSchema = Joi.object({
  selectedPainDescriptions: Joi.array()
    .items(Joi.string())
    .min(1)
    .required()
    .messages({
      "array.min": "Please choose at least one about your pain experience",
      "array.required": "Please choose at least one about your pain experience",
    }),

  painFreq: Joi.string()
    .valid("constant", "intermittent", "occasional")
    .required()
    .messages({
      "string.base": "Please Choose your pain frequency",
      "any.required": "Please Choose your pain frequency",
      "string.empty": "Please choose your pain frequency.",
      "any.only": "Please choose your pain frequency.",
      "any.invalid": "Please choose your pain frequency.",
    })
    .invalid("", null, "pending"),

  painTrigger: Joi.string()
    .valid("at_rest", "being_active", "both", "neither")
    .required()
    .messages({
      "string.base": "Please Choose your pain trigger",
      "any.required": "Please Choose your pain trigger",
      "string.empty": "Please Choose your pain trigger",
      "any.only": "Please Choose your pain trigger",
      "any.invalid": "Please Choose your pain trigger",
    })
    .invalid("", null, "pending"),

  painDailyImpact: Joi.string()
    .valid("none", "little_bit", "moderately", "quite_bit", "extremely")
    .required()
    .messages({
      "string.base": "Please tell us how pain impact your daily activities",
      "any.required": "Please tell us how pain impact your daily activities",
      "string.empty": "Please tell us how pain impact your daily activities",
      "any.only": "Please tell us how pain impact your daily activities",
      "any.invalid": "Please tell us how pain impact your daily activities",
    })
    .invalid("", null, "pending"),

  showTriggerTextBox: Joi.boolean().required().messages({
    "boolean.base": "Please choose if there's any specific pain triggers",
    "any.required": "Please choose if there's any specific pain triggers",
    "any.only": "Please choose if there's any specific pain triggers",
  }),

  showPainChangeTextBox: Joi.boolean().required().messages({
    "boolean.base": "Please choose if your pain change throughout the day",
    "any.only": "Please choose if your pain change throughout the day",
    "any.required": "Please choose if your pain change throughout the day",
  }),

  showPainSevereTimeTextBox: Joi.boolean().required().messages({
    "boolean.base":
      "Please choose if you have severe pain over any specific time",
    "any.required":
      "Please choose if you have severe pain over any specific time",
    "any.only": "Please choose if you have severe pain over any specific time",
  }),

  // painTriggerInfo: Joi.string().optional().messages({
  //   "string.base": "Pain trigger info must be a string.",
  // }),

  // painChangeInfo: Joi.string().optional().messages({
  //   "string.base": "Pain change info must be a string.",
  // }),

  // painSpecificTimeInDayInfo: Joi.string().optional().messages({
  //   "string.base": "Pain specific time in day info must be a string.",
  // }),
}).unknown(true);

const OrderCreamPainDetailsSchema = Joi.object({
  impactedJoints: Joi.string()
    .valid("yes", "no")
    .required()
    .messages({
      "string.base": "Please choose impacted joints.",
      "string.empty": "Please choose impacted joints.",
      "any.required": "Please choose impacted joints.",
      "any.only": "Please choose impacted joints.",
      "any.invalid": "Please choose impacted joints.",
    })
    .invalid("", null, "pending"),

  swelling: Joi.string()
    .valid("yes", "no")
    .required()
    .messages({
      "string.base": "Please choose swelling.",
      "string.empty": "Please choose swelling.",
      "any.required": "Please choose swelling.",
      "any.only": "Please choose swelling.",
      "any.invalid": "Please choose swelling.",
    })
    .invalid("", null, "pending"),

  sleepInterference: Joi.string()
    .valid("yes", "no")
    .required()
    .messages({
      "string.base": "Please choose sleep interference.",
      "string.empty": "Please choose sleep interference.",
      "any.required": "Please choose sleep interference.",
      "any.only": "Please choose sleep interference.",
      "any.invalid": "Please choose sleep interference.",
    })
    .invalid("", null, "pending"),

  burningSensation: Joi.string()
    .valid("yes", "no")
    .required()
    .messages({
      "string.base": "Please choose burning sensation.",
      "string.empty": "Please choose burning sensation.",
      "any.required": "Please choose burning sensation.",
      "any.only": "Please choose burning sensation.",
      "any.invalid": "Please choose burning sensation.",
    })
    .invalid("", null, "pending"),

  specificStimuli: Joi.string()
    .valid("yes", "no")
    .required()
    .messages({
      "string.base": "Please choose specific stimuli.",
      "string.empty": "Please choose specific stimuli.",
      "any.required": "Please choose specific stimuli.",
      "any.only": "Please choose specific stimuli.",
      "any.invalid": "Please choose specific stimuli.",
    })
    .invalid("", null, "pending"),
});

const OrderCreamInjuryHistorySchema = Joi.object({
  hasOpenWound: Joi.string()
    .valid("yes", "no")
    .required()
    .messages({
      "string.base": "Please choose if you have an open wound or not",
      "string.empty": "Please choose if you have an open wound or not",
      "any.required": "Please choose if you have an open wound or not",
      "any.only": "Please choose if you have an open wound or not",
      "any.invalid": "Please choose if you have an open wound or not",
    })
    .invalid("", null, "pending"),

  injuryHistory: Joi.string()
    .valid("yes", "no")
    .required()
    .messages({
      "string.base": "Please choose if you have an injury history or not",
      "string.empty": "Please choose if you have an injury history or not",
      "any.required": "Please choose if you have an injury history or not",
      "any.only": "Please choose if you have an injury history or not",
      "any.invalid": "Please choose if you have an injury history or not",
    })
    .invalid("", null, "pending"),
});

const OrderCreamPainManagementSchema = Joi.object({
  timing: Joi.string()
    .valid("am", "afternoon", "evening", "allday", "varies")
    .required()
    .messages({
      "string.base": "Please choose timing.",
      "string.empty": "Please choose timing.",
      "any.required": "Please choose timing.",
      "any.only": "Please choose timing.",
      "any.invalid": "Please choose timing.",
    })
    .invalid("", null, "pending"),

  painGoal: Joi.string()
    .valid(
      "strength",
      "dailytasks",
      "activities",
      "medication",
      "sleep",
      "other"
    )
    .required()
    .messages({
      "string.base": "Please choose pain goal.",
      "string.empty": "Please choose pain goal.",
      "any.required": "Please choose pain goal.",
      "any.only": "Please choose pain goal.",
      "any.invalid": "Please choose pain goal.",
    })
    .invalid("", null, "pending"),

  applicationFrequency: Joi.string()
    .valid("multiple", "once", "asneeded")
    .required()
    .messages({
      "string.base": "Please choose application frequency.",
      "string.empty": "Please choose application frequency.",
      "any.required": "Please choose application frequency.",
      "any.only": "Please choose application frequency.",
      "any.invalid": "Please choose application frequency.",
    })
    .invalid("", null, "pending"),

  usedBefore: Joi.string()
    .valid("yes", "no")
    .required()
    .messages({
      "string.base": "Please choose if you have used before.",
      "string.empty": "Please choose if you have used before.",
      "any.required": "Please choose if you have used before.",
      "any.only": "Please choose if you have used before.",
      "any.invalid": "Please choose if you have used before.",
    })
    .invalid("", null, "pending"),
}).unknown(true);

export const validateOrderCreamGetStarted = (data: OrderCreamGetStarted) => {
  const { error, value } = OrderCreamGetStartedSchema.validate(data, {
    abortEarly: false,
  });
  if (error) {
    return {
      isError: true,
      errors: error.details.map((err) => err.message),
    };
  } else {
    return {
      isError: false,
      errors: [],
    };
  }
};

export const validatePainProfile = (data: OrderCreamPainProfile) => {
  const { error, value } = OrderCreamPainProfileSchema.validate(data, {
    abortEarly: false,
  });
  if (error) {
    return {
      isError: true,
      errors: error.details.map((err) => err.message),
    };
  } else {
    return {
      isError: false,
      errors: [],
    };
  }
};

export const validatePainFactors = (data: OrderCreamPainFactors) => {
  const { error, value } = OrderCreamPainFactorsSchema.validate(data, {
    abortEarly: false,
  });
  if (error) {
    return {
      isError: true,
      errors: error.details.map((err) => err.message),
    };
  } else {
    return {
      isError: false,
      errors: [],
    };
  }
};

export const validatePainSymptoms = (data: OrderCreamPainSymptoms) => {
  const { error, value } = OrderCreamPainSymptomsSchema.validate(data, {
    abortEarly: false,
  });
  if (error) {
    return {
      isError: true,
      errors: error.details.map((err) => err.message),
    };
  } else {
    return {
      isError: false,
      errors: [],
    };
  }
};

export const validateOrderCreamPainDetails = (data: OrderCreamPainDetails) => {
  const { error, value } = OrderCreamPainDetailsSchema.validate(data, {
    abortEarly: false,
  });
  if (error) {
    return {
      isError: true,
      errors: error.details.map((err) => err.message),
    };
  } else {
    return {
      isError: false,
      errors: [],
    };
  }
};
export const validateOrderCreamInjuryHistory = (data: {
  hasOpenWound: string;
  injuryHistory: string;
}) => {
  const { error, value } = OrderCreamInjuryHistorySchema.validate(data, {
    abortEarly: false,
  });
  if (error) {
    return {
      isError: true,
      errors: error.details.map((err) => err.message),
    };
  } else {
    return {
      isError: false,
      errors: [],
    };
  }
};

export const validateOrderCreamPainManagement = (
  data: OrderCreamPainManagement
) => {
  const { error, value } = OrderCreamPainManagementSchema.validate(data, {
    abortEarly: false,
  });
  if (error) {
    return {
      isError: true,
      errors: error.details.map((err) => err.message),
    };
  } else {
    return {
      isError: false,
      errors: [],
    };
  }
};
